import { makeAd } from "@inferno/renderer-shared-core";
import { AdPosition } from "../../../../core/page-blocks/Ad.component";
import { Container } from "../../../../core/ui";
import "./CoastMedia.style.scss";
import { CoastMediaPlayerSkeleton } from "./CoastMediaPlayerSkeleton.component";
import { CoastMediaTabsSkeleton } from "./CoastMediaTabsSkeleton.component";

export const CoastMediaSkeleton = () => (
  <Container className="component-coast-media">
    <CoastMediaPlayerSkeleton />
    <CoastMediaTabsSkeleton tabs={3} />
    <section className="ads">
      <AdPosition block={makeAd("3308", 0)} />
      <AdPosition block={makeAd("5052", 0)} />
    </section>
  </Container>
);
